import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import { insh as inshst } from "../Context/InshSt";
import moment from "moment";
import { getOrderColorStatues, getOrderStatusLabel } from "./balanceCustRPT-services";
import { Button, Chip, colors, IconButton } from "@material-ui/core";
import { Details, ViewAgenda, ViewHeadlineOutlined, Visibility, VisibilityRounded, VisibilitySharp } from "@material-ui/icons";
moment.locale("ar");
const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
  stickyFooter: {
    position: "fixed",
    minWidth: 650,

    bottom: 0,
  },
}));

export default function BalanceCustRPTTable(props) {
  const { data, isPrinter,title, viewHandle } = props;

  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={{ backgroundColor: colors.lightBlue[50], color: "#000" }}
          >
            <TableCell align="center">
              Order Id{" "}
            </TableCell>
            <TableCell align="center">
              Date
            </TableCell>
            <TableCell align="center">
              customer
            </TableCell>
            <TableCell align="center">
              Products{" "}
            </TableCell>
            <TableCell align="center">
              Total amount     
                      </TableCell>
            <TableCell align="center">
            الحالة 
                           </TableCell>
            <TableCell align="center">
              Action{" "}
            </TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="center">{row.tracking_number}</TableCell>
              <TableCell align="center">{moment(row.created_at).fromNow()}</TableCell>
              <TableCell align="center">{row?.customer_contact}</TableCell>
              <TableCell align="center">
                {row?.products?.length}
              </TableCell>
              
              <TableCell align="center">{row?.total}</TableCell>
              <TableCell align="center">
                <Chip
                  // className={classes.chip}
                  label={getOrderStatusLabel(row.status)}
                  // color={getOrderColorStatues(row?.statues)}
                  style={{
                  backgroundColor:  getOrderColorStatues(row.status) ,
                  color: "#fff",
                  }}
                  size="small"
                  // clickable
              />

                
                </TableCell>

              <TableCell align="center">
              <IconButton
                                    color="primary"
                                    aria-label="upload picture"
                                    // onChange= {getCell(false)}
                                    style={{maxHeight:"0.7rem"}}
                                    onClick={() => {
                                      viewHandle(row);
                                    }}>
                                    <VisibilitySharp size={"small"} />
                                    {/* Details */}
                                </IconButton>

              </TableCell>
             
              <TableCell align="center">{}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableHead>
          <TableRow
            key={"002"}
            className={classes.stickyFooter}
            style={{ backgroundColor: inshst.colors.cust, color: "#fff" }}
          >
            <TableCell style={{ color: "#fff", minWidth: 200 }} align="center">
              الإجماليات{" "}
            </TableCell>
            {/* <TableCell style={{ color: "#fff" }} align="center">
              اسم العميل
            </TableCell> */}
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              {" : مدين"}
              {"  "}
              {data
                ?.reduce((a, v) => (a = a + Number(v.OBX_Dept)), 0)
                ?.toFixed(2)}
            </TableCell>
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              دائن{"  "}
              {data
                ?.reduce((a, v) => (a = a + Number(v.OBX_Credit)), 0)
                ?.toFixed(2)}
            </TableCell>
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              حركة مدين{"  "}
              {data?.reduce((a, v) => (a = a + Number(v.dept)), 0)?.toFixed(2)}
            </TableCell>
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              حركة دائن{"  "}
              {data
                ?.reduce((a, v) => (a = a + Number(v.credit)), 0)
                ?.toFixed(2)}
            </TableCell>
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              الرصيد{"  "}
              {Number(
                data
                  ?.reduce((a, v) => (a = a + Number(v.end_Dept)), 0)
                  ?.toFixed(2)
              ) +
                Number(
                  data
                    ?.reduce((a, v) => (a = a + Number(v.end_Credit)), 0)
                    ?.toFixed(2)
                )}
            </TableCell>
            <TableCell style={{ color: "#fff", minWidth: 170 }} align="center">
              {/* الحالة */}
            </TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
      </Table>
    </TableContainer>
  );
}
